const primary = {
  default: 'blue.base',
  _dark: 'blue.base'
};

const destructive = {
  default: 'red.dark',
  _dark: 'red.light'
};

const tertiary = {
  default: 'green.dark',
  _dark: 'green.dark'
};

const SEMANTIC_TOKENS = {
  colors: {
    primary,
    destructive,
    tertiary
  }
};

export default SEMANTIC_TOKENS;
